import { makeStyles } from '@mui/styles';
import { Theme } from '@mui/material/styles';
import { defaultTheme } from '../../../../lib/themes';

export const useStyles = makeStyles((theme: Theme) => {
  const blue = defaultTheme.palette.primary.trellisBlue;
  const { white } = defaultTheme.palette.primary;
  return {
    icon: {
      paddingLeft: 5,
      fontSize: defaultTheme.font.mediumFontSize,
      color: theme.palette.mode === 'dark' ? white : blue,
      cursor: 'pointer',
    },
    tooltipCustomWidth: {
      maxWidth: 150,
    },
  };
});
